import { useEffect, useState } from "react";
import { CardTaps } from "../../../../theme/Component/CardTaps";
import { AmortizationCreditInfo } from "../../../../../portal/componets/pages/IndexPage/Components/ActiveCredits/Components/AmortizationCreditInfo";
import { HistoryCreditInfo } from "../../../../../portal/componets/pages/IndexPage/Components/ActiveCredits/Components/HistoryCreditInfo";
import { RequestCreditInfo } from "../../ThirdContactInfo/RequestCreditInfo/RequestCreditInfo";
import { PersonalAccountData } from "../../../../../portal/componets/pages/IndexPage/Components/PersonarDataUser/PersonalAccountData";
import { PersonalAccountDataInfo } from "../PersonalAccountDataInfo";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { MASK_DATE, MASK_MONEY } from "../../../../theme/Component/BasicTable";

interface Props {
    _idAccount: number
    Credit: any;
}

export const DetailsThirdContactCreditInfo = ({ _idAccount, Credit }: Props) => {

    const [indexTap, setIndexTap] = useState(0);

    const taps = [
        { id: 0, name: 'Informacion', disable: false },
        { id: 1, name: 'Codeudor', disable: false },
        { id: 2, name: 'Información Afiliado', disable: false },
        { id: 3, name: 'Registro Comunicación', disable: false },
        { id: 4, name: 'Amortización del Credito', disable: false },
        { id: 5, name: 'Movimientos', disable: false }
    ];

    useEffect(() => {
        if (Credit.IDCreditAccount) {
            setIndexTap(0);
        }
    }, [Credit.IDCreditAccount])

    return (
        <div className="row">
            <div className="col-md-12">
                <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap}>
                    <div className="row">
                        {indexTap === 0 &&
                            <div className="row">
                                <div className="col-md-12">
                                    <h5>Crédito</h5>
                                </div>

                                <div className="col-lg-6 my-2">
                                    <strong>Prefijo de Crédito:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: Credit.LoanNumberPrefix }}></div>
                                </div>
                                <div className="col-lg-6 my-2">
                                    <strong>Numero de Crédito:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: Credit.CreditNumber }}></div>
                                </div>
                                <div className="col-lg-6 my-2">
                                    <strong>Estado:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: Credit.StateName }}></div>
                                </div>
                                <div className="col-lg-6 my-2">
                                    <strong>Caja Nominadora:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: Credit.CajaNominadora }}></div>
                                </div>
                                <div className="col-lg-6 my-2">
                                    <strong>Linea de Crédito:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: Credit.NameLoanLine }}></div>
                                </div>
                                <div className="col-lg-6 my-2">
                                    <strong>Inicio:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: Credit.FromDate }}></div>
                                </div>
                                <div className="col-lg-6 my-2">
                                    <strong>Fin:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: Credit.UptoDate }}></div>
                                </div>
                                <div className="col-lg-6 my-2">
                                    <strong>Monto:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: Credit.AmountCredit }}></div>
                                </div>
                                <div className="col-lg-6 my-2">
                                    <strong>Saldo:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: Credit.CurrentCapitalLeft }}></div>
                                </div>
                                <div className="col-lg-6 my-2">
                                    <strong>Tasas de Crédito:</strong>
                                    <div>
                                        {Credit.RateValueCredit} %
                                    </div>
                                </div>
                                <div className="col-lg-6 my-2">
                                    <strong>Tasas de Mora:</strong>
                                    <div>
                                        {Credit.RateValueMora} %
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <hr />
                                    <h5>Deudor</h5>
                                </div>
                                <div className="col-lg-6 my-2">
                                    <strong>Nit:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: Credit.Nit }}></div>
                                </div>
                                <div className="col-lg-6 my-2">
                                    <strong>Nombres y Apellidos:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: Credit.DeudorName }}></div>
                                </div>
                                <div className="col-lg-6 my-2">
                                    <strong>Tipo de Documento:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: Credit.DocTypeName }}></div>
                                </div>
                                <div className="col-lg-6 my-2">
                                    <strong>Fecha de Nacimiento:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: Credit.BornDate }}></div>
                                </div>
                                <div className="col-lg-6 my-2">
                                    <strong>Ciudad:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: Credit.Ciudad }}></div>
                                </div>
                                <div className="col-lg-6 my-2">
                                    <strong>Dirección de Residencia:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: Credit.DireccionResidencia }}></div>
                                </div>
                                <div className="col-lg-6 my-2">
                                    <strong>Télefono:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: Credit.TelefonoVivienda }} />
                                </div>
                                <div className="col-lg-6 my-2">
                                    <strong>Correo Institucional:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: Credit.CorreoInstitucional }} />
                                </div>
                                <div className="col-lg-6 my-2">
                                    <strong>Correo Personal:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: Credit.CorreoPersonal }} />
                                </div>
                                <div className="col-lg-6 my-2">
                                    <strong>Celular:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: Credit.NumeroCelular }} />
                                </div>
                            </div>
                        }
                        {indexTap === 1 &&
                            <PersonalAccountDataInfo idAffiliate={Credit.IDAccountCodeudor} />
                        }
                        {indexTap === 2 &&
                            <PersonalAccountDataInfo idAffiliate={Credit.IDAccount} />
                        }
                        {indexTap === 3 &&
                            <RequestCreditInfo  _CreditID={Credit.IDCreditAccount} isModal />
                        }
                        {indexTap === 4 &&
                            <div className="col-md-12">
                                <AmortizationCreditInfo Credit={Credit} _idAccount={_idAccount} />
                            </div>
                        }
                        {indexTap === 5 &&
                            <div className="col-md-12">
                                <HistoryCreditInfo Credit={Credit} _idAccount={_idAccount} />
                            </div>
                        }

                    </div>
                </CardTaps>
            </div>
        </div>
    )
}